module.exports = __webpack_public_path__ + "static/pcmag-db538ae7125b3407d64704002bbff853.png";